import { StateContext } from "@client/pages/round/Round";
import { memberIsMeanRecommender } from "@client/utils/memberIsMeanRecommender";
import type { Track } from "@lib/types";
import { useContext } from "react";

export default function AdminInclusionTable({
  selectedTrack,
}: {
  selectedTrack: Track;
}) {
  const { round } = useContext(StateContext);

  return (
    <table className="border-collapse border light:border-gray-300 dark:border-stone-700">
      <thead>
        <tr className="bg-gray-100 dark:bg-stone-700">
          <th className="py-2 px-4">Name</th>
          <th className="py-2 px-4">
            <code>!memberIsMeanRecommender(member)</code>
          </th>
          <th className="py-2 px-4">
            <code>member.track === selectedTrack</code>
          </th>
          <th className="py-2 px-4">Member has a recommender</th>
        </tr>
      </thead>
      <tbody className="border-collapse border light:border-gray-300 dark:border-stone-700 light:bg-white dark:bg-stone-800">
        {Object.values(round.members).map((member) => (
          <tr
            key={member.id}
            className="border-b light:border-gray-300 dark:border-stone-700"
          >
            <td className="py-2 px-4">{member.initials}</td>
            <td className="py-2 px-4">
              {!memberIsMeanRecommender(member) ? "✅" : "❌"}
            </td>
            <td className="py-2 px-4">
              {member.track === selectedTrack ? "✅" : "❌"}
            </td>
            <td className="py-2 px-4">
              {Object.values(member.evaluators).some(
                (evaluator) => evaluator.type === "recommender",
              )
                ? "✅"
                : "❌"}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
